import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import "./login-gn.css";
import LoginModalGn from "./login-modal-gn";
import logoPrivate from '../../assets/images/white_logo.gif'
// import SignInModal from "../sign-in-modal/SignInModal";


export class LoginGn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModalSignIn: false,
      showModalForgotPassword: false,
      showModalRegister: false,
      showModalVideoIntro: false,
      showModalVerifyCode: false,
      showModalSuccessRegister: false,
      userData: null,
      signUpResponse: null,
      registering: false,
      showCloseWindowModal: false
    };
  }

  handleShowModalSignIn = () => {
    this.setState({
      showModalSignIn: true
    });
  };

  handleHiddenModalSignIn = () => {
    this.setState({
      showModalSignIn: false
    });
  };

  render() {
    const { showModalSignIn } = this.state;

    return (
      <div className="gn-container">
        <div className="gn-logo">
          <img src="/gnbrands/gn-logo-and-brands.png" alt="gnbrands" />
        </div>
        <div>
          <img src="/gnbrands/texto-home-2.png" alt="gyn-brands" />
        </div>
        <div className="gn-btn-login" onClick={this.handleShowModalSignIn}>
          Iniciar sesión
        </div>
        <div className="gn-images">
          <img src="/gnbrands/f1.jpg" alt="gyn-brands" />
          <img src="/gnbrands/f2.jpg" alt="gyn-brands" />
          <img src="/gnbrands/f3.jpg" alt="gyn-brands" />
          <img src="/gnbrands/f4.jpg" alt="gyn-brands" />
          <img src="/gnbrands/f5.jpg" alt="gyn-brands" />

        </div>
        <div>
          <img src={logoPrivate} alt="Bunkey" style={{ width: 160, marginLeft: -5 }} />
        </div>
        {showModalSignIn && (
          <LoginModalGn
            handleHiddenModalSignIn={this.handleHiddenModalSignIn}
            handleShowModalRegister={this.handleShowModalRegister}
            handleShowModalForgotPassword={this.handleShowModalForgotPassword}
            showModalSignIn={showModalSignIn}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginGn))
);
